import { render, staticRenderFns } from "./articulos_admin.vue?vue&type=template&id=fe344ef0&scoped=true&"
import script from "./articulos_admin.vue?vue&type=script&lang=js&"
export * from "./articulos_admin.vue?vue&type=script&lang=js&"
import style0 from "./articulos_admin.vue?vue&type=style&index=0&id=fe344ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe344ef0",
  null
  
)

export default component.exports